export const ScrollTrigger = (nodeList) => {

    const entries = [...nodeList]
    reveal(entries)
    window.addEventListener('scroll', () => {
        reveal(entries)
    }, { passive: true })

    function reveal(entries) {
        if (entries.length) {
            entries.forEach(function (entry, index) {
                if (isInViewportOrPassed(entry)) {
                    const classToToggle = entry.dataset.scrollTrigger ?? 'reveald'
                    const countTo = parseFloat(entry.dataset.countTo) ?? false
                    if (classToToggle) {
                        classToToggle.split(',').map(className => entry.classList.toggle(className))
                    }

                    if (countTo) {
                        //animation from 0 to x
                        countFromTo(entry,0,countTo)
                    }

                    //only do the class change once
                    delete entries[index]
                }
            });
        }
    }

    function isInViewportOrPassed(el) {
        const rect = el.getBoundingClientRect();
        return (
            //rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
            rect.top <= (window.innerHeight || document.documentElement.clientHeight)
        );
    }

    function countFromTo(element, start, end, ){
        const nbrOfFrames = 31 // nonprime number
        const increaseFactor = end / nbrOfFrames
        const decimalPlaces = (end.toString().split('.')[1] || '').length;

        //no animation for 1
        if (decimalPlaces == 0 && end < 2 ) {
            return false
        }
        element.textContent = start

        let f = setInterval( () => {
            //on end: clear interval and append end (prevent wrong round up from javascript)
            if (start >= nbrOfFrames) {
                clearInterval(f)
                element.textContent = toLocaleFixedFloat(end, decimalPlaces)
                return true
            }
            start++
            element.textContent = toLocaleFixedFloat( increaseFactor * start, decimalPlaces )
          }, 66)
    }

    function toLocaleFixedFloat( float, decimalPlaces = 0) {
        const fixedFloat = parseFloat(parseFloat(float).toFixed(decimalPlaces)) 
        return fixedFloat.toLocaleString( document.documentElement.lang, {
            useGrouping: true,
            minimumFractionDigits: decimalPlaces
        } )
    }

}
